import {ADataGridFilter} from '@atiautomacao/ati-ui-library';
import {Storage} from '../../../Utils/StorageUtils';
import {
    ALARM_ADVANCED_FILTERS_KEY,
    OVERVIEW_ALARM_CATEGORY_FILTER,
    OverviewAlarmCategory,
} from '../Alarms/Components/ChipFilterAlarms/types';
import {SystemRoutes} from '../../../Utils/RouteUtils';

export {OVERVIEW_ALARM_CATEGORY_FILTER};
export type {OverviewAlarmCategory};

const TOTALIZER_ALARM_FILTER_KEY = 'totalizer_alarm_filter';
const ALARM_FILTERS_COUNT_KEY = 'alarm_filters_count';

type CategoryConfig = {
    situation: string;
    severityName?: string;
};

const CATEGORY_CONFIG: Record<OverviewAlarmCategory, CategoryConfig> = {
    CRITICAL: {situation: 'active', severityName: 'critical_with_tele_object~Urgente'},
    NON_CRITICAL: {situation: 'active', severityName: 'Baixa~Média~Alta'},
    EQUIPMENT_NO_COMMUNICATION: {situation: 'equipment_no_communication'},
};

export function buildOverviewAlarmNavigationFilters(
    powerStationId: number,
    category: OverviewAlarmCategory
): ADataGridFilter[] {
    const config = CATEGORY_CONFIG[category];
    const filters: ADataGridFilter[] = [
        {
            name: 'powerStationId',
            condition: 'equals',
            value: String(powerStationId),
            sort: 'none',
        },
        {
            name: 'situation',
            condition: 'equals',
            value: config.situation,
            sort: 'none',
        },
        {
            name: OVERVIEW_ALARM_CATEGORY_FILTER,
            condition: 'equals',
            value: category,
            sort: 'none',
        },
    ];

    if (config.severityName) {
        filters.push({
            name: 'severityName',
            condition: 'equals',
            value: config.severityName,
            sort: 'none',
        });
    }

    return filters;
}

export function persistOverviewAlarmNavigation(
    powerStationId: number,
    category: OverviewAlarmCategory
): void {
    const filters = buildOverviewAlarmNavigationFilters(powerStationId, category);

    Storage.local.set(ALARM_ADVANCED_FILTERS_KEY, filters);
    Storage.local.set(ALARM_FILTERS_COUNT_KEY, filters.length);
    localStorage.removeItem(TOTALIZER_ALARM_FILTER_KEY);
    localStorage.setItem(TOTALIZER_ALARM_FILTER_KEY, 'none');
}

export function navigateToOverviewAlarms(
    navigate: (path: string) => void,
    powerStationId: number,
    category: OverviewAlarmCategory
): void {
    persistOverviewAlarmNavigation(powerStationId, category);
    navigate(SystemRoutes.DASHBOARD_OVERVIEW_ALARMS);
}

export function buildDailyViewActiveAlarmsFilters(): ADataGridFilter[] {
    return [
        {
            name: 'situation',
            condition: 'equals',
            value: 'active',
            sort: 'none',
        },
    ];
}

/**
 * Alarmes ativos da Visão Diária: mantém a seleção de usinas em sessionStorage
 * e não restringe a uma única usina.
 */
export function persistDailyViewActiveAlarmsNavigation(): void {
    const filters = buildDailyViewActiveAlarmsFilters();
    Storage.local.set(ALARM_ADVANCED_FILTERS_KEY, filters);
    Storage.local.set(ALARM_FILTERS_COUNT_KEY, filters.length);
    localStorage.removeItem(TOTALIZER_ALARM_FILTER_KEY);
    localStorage.setItem(TOTALIZER_ALARM_FILTER_KEY, 'none');
}

export function navigateToDailyViewActiveAlarms(navigate: (path: string) => void): void {
    persistDailyViewActiveAlarmsNavigation();
    navigate(SystemRoutes.DASHBOARD_OVERVIEW_ALARMS);
}
